import type { ArgumentTypes } from 'types/utility';

/**
 * Prevent circular dependency issues
 */
export function lazySelector<T extends (...args: any) => any>(
  importPromise: Promise<T>
): (...args: ArgumentTypes<T>) => ReturnType<T> | null {
  let ref: T | null = null;
  importPromise.then(m => (ref = m));
  return (...args) => {
    return ref ? ref(...args) : null;
  };
}
